import React from 'react';
import { Flex, Icon, Typo } from '../../../../ui';
import { useTranslation } from 'react-i18next';

const QuizEmptyState = ({ themeColor }) => {
  const { t } = useTranslation();

  return (
    <Flex direction='column' align='center' justify='center' gap='16' width='100%'>
      <Icon.Questions size='xxl' color={themeColor} />
      <Typo.BigText>{t('quiz.emptyStateTitle')}</Typo.BigText>
      <Typo.MediumText>{t('quiz.emptyStateDescription')}</Typo.MediumText>
    </Flex>
  );
};

export default QuizEmptyState;
